/**
 * Carousel „Nabídka vozů“ – nativní horizontální scroll (kolečko/trackpad).
 * Desktop: myší držení a tahem měníme scrollLeft.
 * Šipky: scrollBy na wrapperu.
 */
(function () {
  'use strict';

  function waitFonts() {
    if (document.fonts && document.fonts.ready) {
      return document.fonts.ready.catch(function () {});
    }
    return Promise.resolve();
  }

  function scrollStepPx(wrap) {
    var w = wrap.clientWidth || 320;
    var raw = getComputedStyle(wrap).columnGap || getComputedStyle(wrap).gap || '16';
    var sp = Number(String(raw).replace(/[^\d.-]/g, '')) || 16;
    var slide0 = wrap.querySelector('.swiper-slide');
    var cw = slide0 ? slide0.getBoundingClientRect().width + sp : 300;
    var cardsPerClick = w < 640 ? 2 : 3;
    return Math.min(w * 0.9, cw * cardsPerClick);
  }

  /** V CSS je výchozí center; při přetečení jen přidáme třídu (flex-start), ať není layout shift od načtení. */
  function syncCarouselOverflowClass(root, wrap) {
    if (!root || !wrap) return;
    var overflows = wrap.scrollWidth > wrap.clientWidth + 1;
    root.classList.toggle('search-product-carousel--has-hscroll', overflows);
  }

  function syncArrowButtons(wrap, prevBtn, nextBtn) {
    if (!prevBtn || !nextBtn) return;
    var maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
    var sl = wrap.scrollLeft;
    var atStart = sl <= 1;
    var atEnd = sl >= maxScroll - 1;
    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
    prevBtn.classList.toggle('swiper-button-disabled', atStart);
    nextBtn.classList.toggle('swiper-button-disabled', atEnd);
    prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function applyNativeScrollMode(host, wrap) {
    if (!host || !wrap) return;

    host.classList.remove('swiper-css-mode', 'swiper-initialized');
    host.classList.add('search-carousel-native');
    wrap.style.scrollSnapType = 'none';
    wrap.style.scrollBehavior = 'auto';
    wrap.style.overflowX = 'auto';

    Array.prototype.forEach.call(wrap.children || [], function (slide) {
      slide.style.scrollSnapAlign = 'none';
      slide.style.scrollSnapStop = 'normal';
    });
  }

  /**
   * Desktop LMB: jen "grab to scroll" nad nativním overflow scrollerem.
   * Swiper se nepoužívá pro drag, jen pro layout a a11y.
   */
  function attachGrabPanScroll(scrollEl, hostEl, onScroll) {
    if (!scrollEl || scrollEl.dataset.grabPanBound === '1') return;
    scrollEl.dataset.grabPanBound = '1';
    hostEl = hostEl || scrollEl.closest('.swiper') || scrollEl.parentElement;
    hostEl.classList.add('search-carousel-grab-target');

    var captureId = null;
    var dragging = false;
    var blockNextClick = false;
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var grabSyncRaf = null;

    hostEl.addEventListener(
      'dragstart',
      function (ev) {
        ev.preventDefault();
      },
      true,
    );

    var docMove = null;
    var docEnd = null;

    function removeDocListeners() {
      if (!docMove || !docEnd) return;
      document.removeEventListener('pointermove', docMove, true);
      document.removeEventListener('pointerup', docEnd, true);
      document.removeEventListener('pointercancel', docEnd, true);
      docMove = null;
      docEnd = null;
    }

    function pointerMoveDuringDrag(e) {
      if (e.pointerType !== 'mouse' || captureId !== e.pointerId) return;

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!dragging) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(dy) > Math.abs(dx) * 1.25) {
          finishDrag(e);
          return;
        }
        dragging = true;
        blockNextClick = true;
        hostEl.classList.add('search-carousel-grab-target--dragging');
        e.preventDefault();
      }

      scrollEl.scrollLeft += lastX - e.clientX;
      lastX = e.clientX;

      if (typeof onScroll === 'function' && dragging) {
        if (!grabSyncRaf) {
          grabSyncRaf = requestAnimationFrame(function () {
            grabSyncRaf = null;
            onScroll();
          });
        }
      }
    }

    function finishDrag(e) {
      if (captureId === null) return;
      if (e && e.pointerId != null && e.pointerId !== captureId) return;
      removeDocListeners();

      if (dragging) {
        hostEl.classList.remove('search-carousel-grab-target--dragging');
        if (typeof onScroll === 'function') onScroll();
      }
      dragging = false;
      captureId = null;
    }

    hostEl.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (!hostEl.contains(e.target)) return;
        var node = /** @type {Node} */ (e.target);
        var elHit =
          node.nodeType === Node.ELEMENT_NODE
            ? /** @type {Element} */ (node)
            : node.parentElement instanceof Element
              ? node.parentElement
              : null;
        if (!elHit || !(scrollEl === elHit || scrollEl.contains(elHit))) return;
        if (scrollEl.scrollWidth <= scrollEl.clientWidth) return;
        if (captureId !== null) return;

        removeDocListeners();

        startX = e.clientX;
        startY = e.clientY;
        lastX = e.clientX;
        dragging = false;
        blockNextClick = false;
        captureId = e.pointerId;

        docMove = pointerMoveDuringDrag;
        docEnd = finishDrag;

        document.addEventListener('pointermove', docMove, { capture: true, passive: false });
        document.addEventListener('pointerup', docEnd, { capture: true, passive: true });
        document.addEventListener('pointercancel', docEnd, { capture: true, passive: true });
      },
      true,
    );

    hostEl.addEventListener(
      'click',
      function (e) {
        if (!blockNextClick) return;
        blockNextClick = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true,
    );
  }

  function attachFreeNav(root, wrap, prevBtn, nextBtn) {
    if (!wrap || wrap.dataset.freeNavBound === '1') return;
    wrap.dataset.freeNavBound = '1';
    var raf = null;

    function scheduleSync() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        syncArrowButtons(wrap, prevBtn, nextBtn);
        syncCarouselOverflowClass(root, wrap);
      });
    }

    function nudge(goNext) {
      var step = scrollStepPx(wrap);
      var maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
      if (maxScroll <= 0) return;
      if (!goNext && wrap.scrollLeft <= 1) return;
      if (goNext && wrap.scrollLeft >= maxScroll - 1) return;
      var target = Math.min(maxScroll, Math.max(0, wrap.scrollLeft + (goNext ? step : -step)));
      wrap.scrollTo({ left: target, top: 0, behavior: 'smooth' });
      requestAnimationFrame(function () {
        syncArrowButtons(wrap, prevBtn, nextBtn);
      });
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (prevBtn.disabled) return;
        nudge(false);
      });
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (nextBtn.disabled) return;
        nudge(true);
      });
    }

    wrap.addEventListener('scroll', scheduleSync, { passive: true });
    function onHostUpdate() {
      syncArrowButtons(wrap, prevBtn, nextBtn);
      syncCarouselOverflowClass(root, wrap);
    }
    window.addEventListener('resize', onHostUpdate, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var resizeTarget = wrap.closest('.swiper--search-products') || wrap.parentElement;
      if (resizeTarget) {
        var roAf = null;
        try {
          new ResizeObserver(function () {
            if (roAf) cancelAnimationFrame(roAf);
            roAf = requestAnimationFrame(function () {
              roAf = null;
              scheduleSync();
            });
          }).observe(resizeTarget);
        } catch (e) {}
      }
    }

    syncArrowButtons(wrap, prevBtn, nextBtn);
    syncCarouselOverflowClass(root, wrap);
  }

  function initSearchProductCarouselFromRoot(root) {
    if (!root || root.dataset.offersCarouselInit === '1') return;
    root.dataset.offersCarouselInit = '1';

    var el = root.querySelector('.swiper.swiper--search-products');
    if (!el) return;

    var sectionId = root.getAttribute('data-section-id');
    var prevBtn = sectionId ? document.getElementById('SearchProductsNavPrev-' + sectionId) : null;
    var nextBtn = sectionId ? document.getElementById('SearchProductsNavNext-' + sectionId) : null;

    var wrap = el.querySelector('.swiper-wrapper');
    if (!wrap) return;
    applyNativeScrollMode(el, wrap);
    attachGrabPanScroll(wrap, el, function () {
      syncArrowButtons(wrap, prevBtn, nextBtn);
      syncCarouselOverflowClass(root, wrap);
    });
    attachFreeNav(root, wrap, prevBtn, nextBtn);

    requestAnimationFrame(function () {
      syncArrowButtons(wrap, prevBtn, nextBtn);
      syncCarouselOverflowClass(root, wrap);
    });

    return wrap;
  }

  function initSearchProductCarousel(scope) {
    var roots = (scope || document).querySelectorAll('[data-search-product-carousel]');
    Array.prototype.forEach.call(roots, function (root) {
      initSearchProductCarouselFromRoot(root);
    });
  }

  function boot(scope) {
    waitFonts().then(function () {
      initSearchProductCarousel(scope || null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(null);
    });
  } else {
    boot(null);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target && ev.target.querySelector && ev.target.querySelector('[data-search-product-carousel]')) {
      boot(ev.target);
    }
  });
})();
